import { render, staticRenderFns } from "./OrderItemsTable.vue?vue&type=template&id=3f8e53a1&scoped=true&"
import script from "./OrderItemsTable.vue?vue&type=script&lang=js&"
export * from "./OrderItemsTable.vue?vue&type=script&lang=js&"
import style0 from "./OrderItemsTable.vue?vue&type=style&index=0&id=3f8e53a1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f8e53a1",
  null
  
)

export default component.exports